/* global _ */
/* global dataLayer */
/* global Blob */
import axios from 'axios';
import moment from 'moment';
import Papa from 'papaparse';
import router from '../router';
import storejs from 'store';
import Vue from 'vue';
import { formatUsageStartDate } from '@utilities';
import { encodeURI } from 'js-base64';

//admin specicific state
const state = {
    //nav control for admin
    delimiter: '^||*|||*||^',
    activeViewAdmin: null,
    queryParamsAdmin: {
      page: 1,
      per_page: 20,
      school_id: 0,
      search: '',
      sort: '',
    },

    //boolean checks for data loading
    adminAjaxing: false,
    adminDataLoaded: false,
    adminFilterContentType: 'Bulbs',
    refreshDataAdmin: false,
    adminBatchLoading: false,

    //selected data
    selectedDataAdmin: [],

    //filters
    adminFilterSearch: {
      creator: {},
      contentType: 'Bulbs',
      organization: [],
      age: [],
      subject: [],
      keywords: [],
      name: [],
      course: [],
      instructor: [],
      youtube: '',
      nodeId: [],
      adminOnly: false,
      tagExactMatch: false,
      excludeTags: [],
      bulbId:'',
    },

    //overall page data and state
    selectedBulbSettings: null,
    showHeaderData: false,
    showGraphData: false,
    showListData: false,
    headerDataLoading: false,
    graphDataLoading: false,
    listDataLoading: false,
    snapshotLoaded: false,
    snapshotsettings: {
      startdate: '',
      enddate: '',
      institution: {
        id: 0,
        name: 'All Organizations'
      },
    },
    bulbsTakenSnapshot: {
      viewed: [],
      delivered: {},
    },
    bulbsCreatedSnapshot: {
      creators: [],
      created: {},
    },
    playlistsCreatedSnapshot: {
      creators: [],
      created: {},
    },
    engagementSnapshot: {
      courses: [],
      playlists: [],
      student: {},
    },
    headerData: {
      instructors: 0,
      students:0,
      bulbs:0,
      minutes:0,
    },

    //table data
    schools: {
      pagination:{},
      data:[]
    },
    instructors: {
      pagination:{},
      data:[]
    },
    bulbs: {
      pagination:{},
      data:[]
    },
    playlists: {},
    treeNodes: {
      pagination:{},
      data:[]
    },
    treeTableData:[],
    //popover state
    addInstructorCsv: {
      upload: false,
      errorLog: [],
      errors: [],
      added: [],
      updated: [],
      nochange: []
    },
    hostedUsage: null,
    manualAddStatus: {
      success: false,
      message: ''
    },
    schoolList: [],
    newBulb: 0,
    courseResults:[],
    courseLoading:false ,
    showSearchCourse:false,
    treeResponseData:[],
    treeNodeData:[],
    treeSubNodeData:[],
    selectedNode:{},
    expandedNode:{},
    removeTreeFolderNode:{},
    addTreeFolderNode:{},
    updateTreeFolderResponse:{},
}

const mutations = {
    updateShowHeaderData: (state, showHeaderData) => state.showHeaderData = showHeaderData,
    updateShowGraphData: (state, showGraphData) => state.showGraphData = showGraphData,
    updateShowListData: (state, showListData) => state.showListData = showListData,
    setActiveView(state, activeView){
      //save main nav selection from side nav
      state.activeViewAdmin = activeView[0]
    },
     //mutations to set activeView, breadcrumbs, and query params
  setQueryParams(state, object) {
      let queryParams = state.queryParamsAdmin;
      let newParams = Object.assign(queryParams, object);
      state.queryParamsAdmin= newParams;
    },
    resetQueryParams(state){
      state.queryParamsAdmin = {
        page: 1,
        per_page: 20,
        school_id: 0,
        search: '',
        sort: '',
      }
    },
    //set selected data
    setSelectedData(state, data){
      state.selectedDataAdmin = data;
    },
    setSelectedBulbSettings(state, bulbId) {
      state.selectedBulbSettings = bulbId;
    },
    clearSelectedData(state){
      state.selectedDataAdmin = []
    },
    setAddTreeFolderNode(state, data){
      state.addTreeFolderNode =data;
    },
    //mutations to set table data
    setTableData(state, object) {
      //sets table data based on activeView
      let rowsPerPage = [];
      if(object.data.total <= 20) rowsPerPage = [object.data.total];
      if(object.data.total > 20 && object.data.total <= 40) rowsPerPage = [20, object.data.total];
      if(object.data.total > 40 && object.data.total <= 60) rowsPerPage = [20, 40, object.data.total];
      if(object.data.total > 60) rowsPerPage = [20, 40, 60, object.data.total];
      switch (object.route) {
        case 'schooldata':
          state.schools.pagination = {
            rowsPerPage: rowsPerPage,
            total : object.data.total,
          };
          state.schools.data = object.data.data;
          state.adminDataLoaded = true;
          break;
        case 'instructordata':
          state.instructors.pagination = {
            rowsPerPage: rowsPerPage,
            total : object.data.total,
          };
          state.instructors.data = object.data.data;
          state.adminDataLoaded = true;
          break;
        case 'bulbdata':
          state.bulbs.pagination = {
            rowsPerPage: rowsPerPage,
            total : object.data.total,
          };
          state.bulbs.data = object.data.data;
          state.playlists = {};
          state.adminDataLoaded = true;
          break;
        case 'treeview':
          if (state.adminFilterSearch.contentType === 'Playlists') {
            state.playlists = object.data;
            state.bulbs = {
              data: [],
              pagination: {},
            };
          } else {
            state.playlists = {};
            state.bulbs.pagination = {
              rowsPerPage: rowsPerPage,
              total : object.data.total,
            };
            state.bulbs.data = object.data.data;
          }
          state.adminDataLoaded = true;
          break;
        case 'playlistData':
          state.playlists = object.data;
          state.bulbs = {
            data: [],
            pagination: {},
          };
          state.adminDataLoaded = true;
          break;
        default:
          break;
      }
    },
    setTreeTableData(state, data){
      state.treeTableData = data;
    },
    setTreeResponseData(state, data){
      state.treeResponseData = data;
    },
    setSchoolList(state, data) {
      if(state.activeViewAdmin === 'Snapshot'){
        data.unshift({
          text: 'All Organizations',
          value: {
            id: 0,
            name: 'All Organizations'
          }
        })
      }
      state.schoolList = data;
    },
    setNewBulb(state, data){
      state.newBulb = data.bulb_id;
    },
    setRemoveTreeFolderNode(state, data){
      state.removeTreeFolderNode = data;
    },
    resetNewBulb(state){
      state.newBulb = 0;
    },
    //mutations for snapshot
    setGraphData(state, data){
      state.engagementSnapshot.student =  {
        labels: data.bulbAttempt.map(d => d.date),
        datasets: [{
          data: data.bulbAttempt.map(d => d.totalEngagementHours),
          label: "Student Engagement",
          borderColor: '#E1E1E1',
          fill: false
        }]
      };
      state.bulbsTakenSnapshot.delivered =  {
        labels: data.bulbAttempt.map(d => d.date),
        datasets: [{
          data: data.bulbAttempt.map(d => d.totalBulbsDelivered),
          label: "Bulbs Delivered",
          borderColor: '#E1E1E1',
          fill: false
        }]
      };
      state.bulbsCreatedSnapshot.created =  {
        labels: data.bulbsCreated.map(d => d.date),
        datasets: [{
          data: data.bulbsCreated.map(d => d.totalBulbsCreated),
          label: "Bulbs Created",
          borderColor: '#E1E1E1',
          fill: false
        }]
      };
      state.playlistsCreatedSnapshot.created =  {
        labels: data.playlistsCreated.map(d => d.date),
        datasets: [{
          data: data.playlistsCreated.map(d => d.totalPlaylistsCreated),
          label: "Playlists Created",
          borderColor: '#E1E1E1',
          fill: false
        }]
      };
      state.graphDataLoading = false;
      state.snapshotLoaded = true;
    },
    setListData(state, data){
      state.engagementSnapshot.courses = data.courses;
      state.engagementSnapshot.playlists = data.playlists;
      state.bulbsTakenSnapshot.viewed = data.viewed;
      state.bulbsCreatedSnapshot.creators = data.creators;

      state.listDataLoading = false;
      state.snapshotLoaded = true;
    },
    setHeaderData(state, data){
      state.headerData.instructors = data.instructors;
      state.headerData.bulbs = data.bulbs;
      state.headerData.minutes = data.minutes;
      state.headerData.students = data.students;

      state.headerDataLoading = false;
    },
    setSnapshotSettings(state, obj) {
      state.snapshotsettings.institution = obj.institution;
      state.snapshotsettings.startdate = obj.startdate;
      // If the filter date is not today, set it to the latest timestamp.  Otherwise set it to the current timestamp.
      const timeStamp = moment().format('yyyy-MM-DD') !== obj.enddate.split(' ')[0] ? '23:59:59' : moment().format('HH:mm:ss')
      state.snapshotsettings.enddate = obj.enddate.split(' ')[0] + ` ${timeStamp}`;
    },
    setSnapshotFilterDate(state, obj) {
      if (obj.usageStartDate) {
        // Use the most recent month and date (not the year) of the last year as the usage_start_date in the admin snapshot
        state.snapshotsettings.startdate = formatUsageStartDate(obj.usageStartDate);
      } else {
        state.snapshotsettings.startdate = formatUsageStartDate();
      }
      state.snapshotsettings.enddate = moment().format("YYYY-MM-DD HH:mm:ss");
    },
    //mutations to reset data
    refreshDataAdmin (state){
      //trigger data refresh after an update, creation, or deletion
      state.refreshDataAdmin = true;
    },
    refreshComplete(state){
      //turn off data refresh
      state.refreshDataAdmin = false;
    },
    //mutations for filters
    setSchoolFilter(state, data){
      state.adminFilterSearch.organization = [{text:data.name, value:data}];
    },
    setAdminAjaxing(state, value) {
      state.adminAjaxing = value;
    },
    setAdminFilters(state, obj){
      state.adminFilterSearch.age = obj.age;
      state.adminFilterSearch.contentType = obj.contentType;
      state.adminFilterSearch.subject = obj.subject;
      state.adminFilterSearch.keywords = obj.keywords;
      state.adminFilterSearch.name = obj.name;
      state.adminFilterSearch.instructor = obj.instructor;
      state.adminFilterSearch.organization = obj.organization;
      state.adminFilterSearch.creator = obj.creator;
      state.adminFilterSearch.youtube = obj.youtube;
      state.adminFilterSearch.course = obj.course;
      state.adminFilterSearch.adminOnly = obj.adminOnly;
      state.adminFilterSearch.tagExactMatch = obj.tagExactMatch;
      state.adminFilterSearch.bulbId = obj.bulbId;
      state.adminFilterSearch.excludeTags = obj.excludeTags;
      state.refreshDataAdmin = true;
    },
    setAdminNodeIdFilter(state, obj){
      state.adminFilterSearch.nodeId = obj.nodeId;
    },
    setAdminFilterContentType(state, value) {
      state.adminFilterContentType = value;
    },
    clearFilter(state, type) {
      if(type[0] === 'Creator'){
        state.adminFilterSearch.creator = {};
      } else if(type[0] === 'Organization'){
        let indexOrg;
        state.adminFilterSearch.organization.forEach((item, index) => {
          if(item.text === type[1]){
            indexOrg = index;
          }
        })
        state.adminFilterSearch.organization.splice(indexOrg, 1);
        state.queryParamsAdmin.school_id = 0;
      } else if (type[0] === "Keywords/Tags"){
        let index = state.adminFilterSearch.keywords.indexOf(type[1]);
        state.adminFilterSearch.keywords.splice(index, 1);
      } else if (type[0] === "Exclude Tags"){
        let index = state.adminFilterSearch.excludeTags.indexOf(type[1]);
        state.adminFilterSearch.excludeTags.splice(index, 1);
      } else if (type[0] === "Bulb-Name" || type[0] === 'Playlist-Name'){
        let index = state.adminFilterSearch.name.indexOf(type[1]);
        state.adminFilterSearch.name.splice(index, 1);
      } else if (type[0] === "Creator-Name"){
        let index = state.adminFilterSearch.instructor.indexOf(type[1]);
        state.adminFilterSearch.instructor.splice(index, 1);
      } else if (type[0] === "Audience"){
        let index = state.adminFilterSearch.age.indexOf(type[1]);
        state.adminFilterSearch.age.splice(index, 1);
      } else if (type[0] === "Subject"){
        let index = state.adminFilterSearch.subject.indexOf(type[1]);
        state.adminFilterSearch.subject.splice(index, 1);
      } else if(type[0] === 'Youtube-Video'){
        state.adminFilterSearch.youtube = ''
      } else if(type[0] === 'Course'){
        if(state.adminFilterSearch.course){
          let index = state.adminFilterSearch.course.map(function(item) { return item.name; }).indexOf(type[1]);
          state.adminFilterSearch.course.splice(index, 1);
        }
      } else if(type[0] === 'All-Instructors'){
        state.adminFilterSearch.adminOnly = false;
      } else if(type[0] === "Bulb-Id") {
        let index = state.adminFilterSearch.bulbId.indexOf(type[1]);
        state.adminFilterSearch.bulbId.splice(index, 1);
      }
      state.refreshDataAdmin = true;
    },
    clearAllFilters(state){
      state.adminFilterSearch = {
        creator: {},
        contentType: state.adminFilterContentType,
        organization: [],
        age: [],
        subject: [],
        keywords: [],
        name: [],
        instructor: [],
        youtube: '',
        nodeId:[],
        course: [],
        adminOnly: false,
        tagExactMatch: false,
        excludeTags: [],
        bulbId:'',
      };
      state.queryParamsAdmin.school_id = 0;

      state.refreshDataAdmin = true;
    },
    clearAllFiltersNoReload(state){
      state.adminFilterSearch = {
        creator: {},
        organization: [],
        age: [],
        subject: [],
        keywords: [],
        name: [],
        instructor: [],
        course: [],
        youtube: '',
        nodeId:[],
        adminOnly: false,
        tagExactMatch: false,
        excludeTags: [],
        bulbId:'',
      }
      state.queryParamsAdmin.school_id = 0;
    },
    //popover mutations
    setInstructorUploadData(state, data) {
      if(data.added.length > 0) state.addInstructorCsv.added = data.added;
      if(data.nochange.length > 0) state.addInstructorCsv.nochange = data.nochange;
      if(data.updated.length > 0) state.addInstructorCsv.updated = data.updated;
      if(data.errors.length > 0) state.addInstructorCsv.errors = data.errors;
      state.addInstructorCsv.upload = false;
    },
    clearInstructorUploadData(state){
      state.addInstructorCsv.added = [];
      state.addInstructorCsv.updated = [];
      state.addInstructorCsv.errors = [];
      state.addInstructorCsv.nochange = [];
      state.addInstructorCsv.upload = false;
    },
    setAddSingleTeacher(state, data){
      state.manualAddStatus =  {
        success: data.success,
        message: data.message
      }
      //refresh data after setting message
      state.adminAjaxing = false;
      state.refreshDataAdmin= true;
    },
    resetManualAddInstructor(state){
      state.manualAddStatus =  {
        success: false,
        message: ''
      }
    },
    updateCourse(state, data){
      state.courseResults = data;
    },
    setCourseLoadBar(state){
      state.courseLoading = true;
    },
    setTreeFolder(state, data){
      state.treeNodeData = data;  
    },
    setSelectedNode(state, data){
      state.selectedNode = data;
    },
    setExpandedNode(state, data){
      state.expandedNode = data;
    },
    setTreeSubNodeData(state, data){
      state.treeSubNodeData = data;
    },
    setUpdateTreeFolderResponse(state, data){
      state.updateTreeFolderResponse = data;
    },
    clearBulbData(state){
      state.bulbs = {
        pagination:{},
        data:[]
      }
    }
}

const actions = {
    updateUrl: ({state, rootState}) => {
        // updates the url on changes to table including activeView and all query params
        router.push({name: 'admin',
        params:{activeView:rootState.activeView, secondaryView:state.activeViewAdmin},
        query:{
            school_id: state.queryParamsAdmin.school_id,
            page :state.queryParamsAdmin.page,
            per_page: state.queryParamsAdmin.per_page,
            search: state.queryParamsAdmin.search,
            sort: state.queryParamsAdmin.sort,
            breadcrumbs: encodeURI(JSON.stringify(rootState.breadcrumbs)),
          },
        }).catch(err => {
          console.log('err from update url', err)
        })

        //set array to blank array, find data from storejs if available
        let array = []
        if(storejs.get('url')){
          array = storejs.get('url');
        }

        //push state to storejs for back button functionality
        array.push({path:router.history.current.fullPath,  data:{name: 'admin',
        params:{activeView:rootState.activeView, secondaryView:state.activeViewAdmin},
        query:{
            school_id: state.queryParamsAdmin.school_id ,
            page :state.queryParamsAdmin.page,
            per_page: state.queryParamsAdmin.per_page,
            search: state.queryParamsAdmin.search,
            sort: state.queryParamsAdmin.sort,
            breadcrumbs: encodeURI(JSON.stringify(rootState.breadcrumbs)),
          },
        }})
        storejs.set('url', array);
    },
    //quick call to get school list
    getSchoolList: ({commit, state, rootState}, boolean) => {
      axios.get(`${rootState.nodeApiPrefix}/admin/getschoollist?selectionFormat=${boolean}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        .then(res => {
          if(res.data.msg === "success") {
            commit('setSchoolList', res.data.data);
          }
        }).catch(err => {
          console.error(err);
          dataLayer.errorLog(err);
          commit('triggerSnackbar', {text:`Organization list not found at this time.`, color: 'red', timeout: 6000} , {root:true});
        });
    },
    getBulbRolePermission: ({commit, state, rootState}, bulbId) => {
      axios.post(`${rootState.nodeApiPrefix}/instructor/bulbs/${bulbId}/roles?permission_type=edit&set_permissions=true`, {}, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        .then(res => {
          if(res && res.data.data && res.data.data.permission) {
            //opens editor
            window.open(`${rootState.designerApiPrefix}/designer/?bulb_id=${bulbId}&token=${rootState.instructorData.token}&lms_launch=${rootState.LTIlaunch}`);
          }
          else {
            // -show error
            commit('triggerSnackbar', {text:"Error getting permission for bulb edit. Please try again", color: 'red', timeout: 6000} , {root:true});
          }
        }).catch(err => {
          console.error(err);
          dataLayer.errorLog(err);
          commit('triggerSnackbar', {text:"Error getting permission for bulb edit. Please try again", color: 'red', timeout: 6000} , {root:true});
      });
    },
    getBulbSections: async ({commit, state, rootState }, bulbId) => {
      try {
        state.instructorAjaxing = true;
        const bsResponse = await axios.get(`${rootState.nodeApiPrefix}/admin/bulb/${bulbId}/bulbsections`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token }` } });
        return bsResponse.data;
      } catch (error) {
        dataLayer.axiosLog(error);
        return [];
      } finally {
        state.instructorAjaxing = false;
      }
    },
    getHostedUsage: async ({
          commit,
          state,
          rootState
        }) => {
      try {
        state.instructorAjaxing = true;
        const usage = await axios.get(
          `${rootState.nodeApiPrefix}/admin/hosted`, {
            headers: {
              'Authorization': `Bearer ${rootState.instructorData.token }`
            }
          });
        state.hostedUsage = _.get(usage, 'data.currentHostingMinutes', null);
        return usage;
      } catch (error) {
        dataLayer.axiosLog(error);
        return [];
      } finally {
        state.instructorAjaxing = false;
      }
    },
    //Data call for Table Component
  getTableData: ({ commit, state, rootState }) => {
      //set route to get table data
      let route,endpoint;
      switch (state.activeViewAdmin) {
        case 'Schools':
              route = 'schooldata'
              endpoint = `organizations`
              break;
        case 'Instructors':
              route = 'instructordata'
              endpoint = `organizations/${state.queryParamsAdmin.school_id}/instructors`
              break;
        case 'Bulbs':
              route = state.adminFilterSearch.contentType === 'Playlists' ? 'playlistData' : 'bulbdata';
              endpoint = state.adminFilterSearch.contentType === 'Playlists' ? `organizations/${state.queryParamsAdmin.school_id}/playlists`
                : `organizations/${state.queryParamsAdmin.school_id}/bulbs`;
              break;
        case 'Treeview':
              route = 'treeview';
              endpoint = state.adminFilterSearch.contentType === 'Playlists' ? `organizations/${state.queryParamsAdmin.school_id}/playlists`
                : `organizations/${state.queryParamsAdmin.school_id}/bulbs`;
              break;
        default:
            console.log("Error: Please add route to admin's getTableData switch function")
            break;
      }
      //data call for table component based on activeView
    if (!state.adminAjaxing) {
        state.adminAjaxing = true;  
        state.adminDataLoaded = false;

        let teacher_id = ''
        if(Object.keys(state.adminFilterSearch.creator).length > 0){
          teacher_id = state.adminFilterSearch.creator.id;
        }

        let organization = '';
        if(state.adminFilterSearch.organization.length > 0){
          state.adminFilterSearch.organization.forEach((item, index) => {
            organization += item.value.id;
            if((index + 1 < state.adminFilterSearch.organization.length)){
              organization += ','
            }
          })
        }

        let name = '';
        if(state.adminFilterSearch.name.length > 0){
          state.adminFilterSearch.name.forEach((item, index) => {
            name += item;
            if((index + 1 < state.adminFilterSearch.name.length)){
              name += state.delimiter;
            }
          })
        }

        let instructor = '';
        if(state.adminFilterSearch.instructor.length > 0){
          state.adminFilterSearch.instructor.forEach((item, index) => {
            instructor += item;
            if((index + 1 < state.adminFilterSearch.instructor.length)){
              instructor += ','
            }
          })
        }

        let video = '';
        if(state.adminFilterSearch.youtube != ''){
          video = state.adminFilterSearch.youtube;
        }

        let keywords = '';
        if(state.adminFilterSearch.keywords.length > 0){
          state.adminFilterSearch.keywords.forEach((item, index) => {
            keywords += item;
            if((index + 1 < state.adminFilterSearch.keywords.length)){
              keywords += ','
            }
          })
        }

      let excludeTags = '';
      if (
        state.adminFilterSearch.excludeTags
        && state.adminFilterSearch.excludeTags.length > 0
      ) {
          state.adminFilterSearch.excludeTags.forEach((item, index) => {
            excludeTags += item;
            if ((index + 1 < state.adminFilterSearch.excludeTags.length)) excludeTags += ',';
          })
        }

        let age = '';
        if(state.adminFilterSearch.age.length > 0){
          state.adminFilterSearch.age.forEach((item, index) => {
            age += item;
            if((index + 1 < state.adminFilterSearch.age.length)){
              age += ','
            }
          })
        }

        let subject = '';
        if(state.adminFilterSearch.subject.length > 0){
          state.adminFilterSearch.subject.forEach((item, index) => {
            subject += item;
            if((index + 1 < state.adminFilterSearch.subject.length)){
              subject += ','
            }
          })
        }
        
        let course = '';
        if(state.adminFilterSearch.course && state.adminFilterSearch.course.length > 0){
          const coursesList = _.map(state.adminFilterSearch.course, 'id');
          course = coursesList.length > 0 ? coursesList.join(',') : '';
        }
        
        let nodeId ='';
        if(route == 'treeview'){
          if(typeof state.adminFilterSearch.nodeId == "number"){
            nodeId = state.adminFilterSearch.nodeId;
          } else {
            nodeId = 'root';
          }
        }
        
        let bulbId ='';
        if(state.adminFilterSearch.bulbId && state.adminFilterSearch.bulbId.length > 0){
          bulbId = state.adminFilterSearch.bulbId.join(",");
        }
        
        let adminOnly = false;
        if(state.adminFilterSearch.adminOnly) {
          adminOnly = true;
        }
        const timezone = (rootState.instructorData && rootState.instructorData.timezone) ? rootState.instructorData.timezone : '';
        axios.get(`${rootState.nodeApiPrefix}/admin/${endpoint}?school=${state.queryParamsAdmin.school_id}&page=${state.queryParamsAdmin.page}&per_page=${state.queryParamsAdmin.per_page}&search=${state.queryParamsAdmin.search}&sort=${state.queryParamsAdmin.sort}&teacher_search=${teacher_id}&organization=${organization}&name=${encodeURIComponent(name)}&instructor=${encodeURIComponent(instructor)}&video=${video}&keywords=${encodeURIComponent(keywords)}&tag_exact_match=${state.adminFilterSearch.tagExactMatch}&age=${age}&subject=${subject}&section=${course}&admin_only=${adminOnly}&nodeId=${nodeId}&timezone=${timezone}&contentType=${state.adminFilterSearch.contentType}&bulbId=${bulbId}&excludeTags=${encodeURIComponent(excludeTags)}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        .then(res => {
          if (res.data.msg === "success") {
            commit('setTableData', {data: res.data.data, route: route});
            state.adminAjaxing = false;
            if(state.queryParamsAdmin.school_id != 0){
              commit('setSchoolFilter', {id: state.queryParamsAdmin.school_id, name:res.data.data.school_name});
            }
          }
        }).catch(err => {
          console.error(err);
          dataLayer.errorLog(err);
          commit('triggerSnackbar', {text:`${state.activeViewAdmin} data cannot load at this time`, color: 'red', timeout: 6000} , {root:true});
          state.adminAjaxing = false;
          state.adminDataLoaded = true;
        });
      }
    },
    getSnapshotHeaderData: async ({commit, state, rootState}) => {
      try {
        if(!state.headerDataLoading) {
          state.headerDataLoading = true;
          const headerData = await axios.get(`${rootState.nodeApiPrefix}/admin/organizations/${state.snapshotsettings.institution.id}/headers?startdate=${state.snapshotsettings.startdate}&enddate=${state.snapshotsettings.enddate}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}});
          commit('setHeaderData', headerData.data);
        }
      } catch (error) {
        console.error(error);
        dataLayer.errorLog(error);
        state.headerDataLoading = false;
        commit('triggerSnackbar', {text:"Getting admin snapshot header data not working at this time", color: 'red', timeout: 6000} , {root:true});
      }
    },
    getSnapshotGraphData: async ({commit, state, rootState}) => {
      try {
        if (!state.graphDataLoading) {
          state.graphDataLoading = true;
          const graphData = await axios.get(`${rootState.nodeApiPrefix}/admin/organizations/${state.snapshotsettings.institution.id}/graphs?startdate=${state.snapshotsettings.startdate}&enddate=${state.snapshotsettings.enddate}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
          commit('setGraphData', graphData.data);
        }
      } catch (error) {
        console.error(error);
        dataLayer.errorLog(error);
        state.graphDataLoading = false;
        commit('triggerSnackbar', { text: "Getting admin snapshot graph data not working at this time", color: 'red', timeout: 6000 }, { root: true });
      }
    },
    getSnapshotListData: async ({commit, state, rootState}) => {
      try {
        if(!state.listDataLoading) {
          state.listDataLoading = true;
          const listData = await axios.get(`${rootState.nodeApiPrefix}/admin/organizations/${state.snapshotsettings.institution.id}/lists?startdate=${state.snapshotsettings.startdate}&enddate=${state.snapshotsettings.enddate}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}});
          commit('setListData', listData.data);
        }
      } catch (error) {
        console.error(error);
        dataLayer.errorLog(error);
        state.listDataLoading = false;
        commit('triggerSnackbar', {text:"Getting admin snapshot list data not working at this time", color: 'red', timeout: 6000} , {root:true});
      }
    },
    getSnapshotData: async ({commit, state, rootState}) => {
      try {
        if (!state.headerDataLoading && state.showHeaderData) {
          state.headerDataLoading = true;
          const headerData = await axios.get(`${rootState.nodeApiPrefix}/admin/organizations/${state.snapshotsettings.institution.id}/headers/?startdate=${state.snapshotsettings.startdate}&enddate=${state.snapshotsettings.enddate}&school_id=${state.snapshotsettings.institution.id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
          commit('setHeaderData', headerData.data);
        }
        if (!state.graphDataLoading && state.showGraphData) {
          state.graphDataLoading = true;
          const graphData = await axios.get(`${rootState.nodeApiPrefix}/admin/organizations/${state.snapshotsettings.institution.id}/graphs?startdate=${state.snapshotsettings.startdate}&enddate=${state.snapshotsettings.enddate}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
          commit('setGraphData', graphData.data)
        }
        if (!state.listDataLoading && state.showListData) {
          state.listDataLoading = true;
          const listData = await axios.get(`${rootState.nodeApiPrefix}/admin/organizations/${state.snapshotsettings.institution.id}/lists?startdate=${state.snapshotsettings.startdate}&enddate=${state.snapshotsettings.enddate}&school_id=${state.snapshotsettings.institution.id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
          commit('setListData', listData.data);
        }
      } catch (e) {
        console.error(e);
        dataLayer.errorLog(e);
        state.headerDataLoading = false;
        commit('triggerSnackbar', { text: "Getting admin snapshot data not working at this time", color: 'red', timeout: 6000 }, { root: true });
      }
    },
    launchAdminPlaylist: async (context, data) => {
      try {
        context.state.adminDataLoaded = false;
        context.state.adminAjaxing = true;
        const { data: playlistHash } = await axios.get(`${context.rootState.nodeApiPrefix}/admin/playlist/?playlistId=${data.playlistId}`,
        {
          headers: {
            'Authorization': `Bearer ${context.rootState.instructorData.token}`
          }
        });
        window.open(`${context.rootState.nodeApiPrefix}/course/${playlistHash}?token=${context.rootState.instructorData.token}${data.preview ? '&preview=true' : ''}`);
      } catch(e) {
        context.commit('triggerSnackbar',
          {
            text:"Error lauching Playlist preview.",
            color: 'red',
            timeout: 6000
          },
          {
            root:true
          }
        );
      } finally {
        context.state.adminAjaxing = false;
        context.state.adminDataLoaded = true;
      }
    },
    signInAsTeacher: ({commit, state, rootState}, id) => {
      let postData = {}
      axios.post(`${rootState.nodeApiPrefix}/admin/instructors/${id}`, postData, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        .then(res => {
          if(res.data.msg === "success") {
            window.open(`${rootState.nodeApiPrefix}/dash/?token=${res.data.data}&isTeacherBeingImpersonated=true`);
          }
        }).catch(err => {
          console.error(err);
          dataLayer.errorLog(err);
          commit('triggerSnackbar', {text:"Instructor sign in is not working at this time", color: 'red', timeout: 6000} , {root:true});
        });

    },
    uploadTeacherCsv: ({commit, state, rootState}, file ) => {

     if(!state.addInstructorCsv.upload){
       state.addInstructorCsv.upload = true;
       state.addInstructorCsv.errorLog = [];
       state.addInstructorCsv.errors = [];
       state.addInstructorCsv.added= [];
       state.addInstructorCsv.uploaded = [];
       state.addInstructorCsv.school_name = '';
       Papa.parse(file, {
        header: true,
        error(){
          state.addInstructorCsv.errorLog = ['Unable to parse csv. Please check it is correctly formatted']
          dataLayer.errorLog(state.errorLog);
          state.addInstructorCsv.upload = false;
        },
      	complete(results) {
      	  // Converts csv to JSON with headers.
      	  // If the section id is not defined, then will be extracted from the csv on the backend
      	  const removeEmptyLastLine = (data) => {
            // An extra row is somtimes parsed from csv to json
            // This removes it
            var lastrow = data[data.length-1],
          	    hascontent = false;
          	 for(var key in lastrow){
          	    if(lastrow[key]) hascontent = true;
          	  }
              if(!hascontent){
                data.pop();
              }
           }

      	   removeEmptyLastLine(results.data);

      	   if(results.data.length === 0){
      	    state.addInstructorCsv.errorLog = ['You cannot upload an empty file.']
      	    state.addInstructorCsv.upload = false;
      	    return;
      	   }

      	   //checks for a correctly formatted csv
            const checkFields = (fields) => {
              if(fields[0] === "first_name" && fields[1] === "last_name" && fields[2] === "email" && fields[3] === "password (Min 8 characters|at least 1 of uppercase lowercase and number|No spaces)" && fields[4] === "organization") return true;
              else return false;
            }


        	  // Passes json csv to backend, returns if success or invalid fields
        	  if(checkFields(results.meta.fields)){
               axios.patch(`${rootState.nodeApiPrefix}/admin/organizations/0/instructors`, {instructors: results.data}, {headers:{
                 'Authorization' : `Bearer ${rootState.instructorData.token}`
               }}).then(res => {
                if(res.data.msg === 'success'){
                  commit('setInstructorUploadData', res.data.data);
                  state.refreshDataAdmin= true;
                }

               }).catch(err => {
                 console.error(err);
                 dataLayer.errorLog(err);
                 state.addInstructorCsv.upload = false;
                 const message = err.message === 'Request failed with status code 400' ? '. Please make sure your file does not exceed 1000 rows.' : '';
                 state.addInstructorCsv.errorLog = ['Failed to upload: ' + err + message];
               })
        	  } else {
        	    state.addInstructorCsv.errorLog = ['Your CSV format does not match the template. Please download the template, add instructors, and try again.'];
          	  state.addInstructorCsv.upload = false;
          	  return;
        	  }
          }
        })

     } else {
       commit('triggerSnackbar', {text:"Instructor upload in progress. Please wait.", color: 'red', timeout: 6000} , {root:true});
     }
    },
    updateAdminBulbSettings: async ({ commit, state, rootState }, bulb) => {
      try {
        state.adminBatchLoading = true;
        const bulbData = await axios.post(`${rootState.nodeApiPrefix}/instructor/updatebulbsettings`, bulb, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
        const tagData = await axios.get(`${rootState.nodeApiPrefix}/admin/bulbs/${bulb.bulb_id}/tags`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
        return { bulbData, tagData };
      } catch (err) {
        //if error, log error, trigger snackbar and turn off ajaxing
        console.error(err);
        dataLayer.errorLog(err.response);
        commit('triggerSnackbar', { text: "Adding tags to bulb did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
      } finally {
        state.adminBatchLoading = false;
        commit('refreshDataAdmin');
      }
    },
    addInstructor: ({commit, state, rootState}, obj ) => {
      if(!state.adminAjaxing){
        state.adminAjaxing = true;
        state.manualAddStatus = {
          success: false,
          message: ''
        }
        axios.post(`${rootState.nodeApiPrefix}/admin/organizations/${obj.schoolId}/instructors`, obj, {headers:{
           'Authorization' : `Bearer ${rootState.instructorData.token}`
        }}).then(res => {
          if(res.data.msg === 'success'){
            commit('setAddSingleTeacher', res.data.data);
          }
        }).catch(err => {
           state.adminAjaxing = false;
           console.error(err);
           dataLayer.errorLog(err);
           commit('setAddSingleTeacher', {success:false, message:"Adding instructor failed. Try again later or contact PlayPosit support."});
        })
      }
    },
    //Create new folder in the tree folder
    createNodeFolder: ({commit, state,rootState}, obj) => {
      axios.post(`${rootState.nodeApiPrefix}/admin/node/folder`, obj, {headers: {
           'Authorization' : `Bearer ${rootState.instructorData.token}`
        }}).then( async res => {
          if(res.data.msg === 'success'){
            rootState.popoverToggles.addFolder = false;
            rootState.dialogShow.dash = false;
            rootState.adminAjaxing = true;
            commit('setAddTreeFolderNode',res.data.data);
          }
        }).catch(err => {
          console.error(err);
          commit('triggerSnackbar', {text:"Adding folder failed at this time. Please try again later.", color: 'red', timeout: 6000} , {root:true});
        })
    },
    editInstructors: ({commit, state, rootState}, obj ) => {
      if(!state.adminAjaxing){
        state.adminAjaxing = true;
        if(obj.multiple){
          obj.instructors = []
          state.selectedDataAdmin.forEach(item => obj.instructors.push(item.id))
        } else {
          obj.instructors = [state.selectedDataAdmin[0].id]
        }

        axios.put(`${rootState.nodeApiPrefix}/admin/organizations/${obj.schoolId}/instructors`, obj, {headers:{
           'Authorization' : `Bearer ${rootState.instructorData.token}`
        }}).then(res => {
          if(res.data.msg === 'success'){
            state.selectedDataAdmin = [];
            state.adminAjaxing = false;
            state.refreshDataAdmin= true;
          }
        }).catch(err => {
           state.adminAjaxing = false;
           state.selectedDataAdmin = [];
           console.error(err);
           dataLayer.errorLog(err);
           commit('triggerSnackbar', {text:"Editing instructor failed at this time. Please try again later.", color: 'red', timeout: 6000} , {root:true});
        })
      }
    },
    removeInstructors: ({commit, state, rootState}, obj ) => {
      if(!state.adminAjaxing){
        state.adminAjaxing = true;

        let instructors = []
        state.selectedDataAdmin.forEach(item => instructors.push(item.id))


        axios.delete(`${rootState.nodeApiPrefix}/admin/organizations/all/instructors`, { data:{instructors:instructors}, headers:{
           'Authorization' : `Bearer ${rootState.instructorData.token}`
        }}).then(res => {
          if(res.data.msg === 'success'){
            state.selectedDataAdmin = [];
            state.adminAjaxing = false;
            state.refreshDataAdmin= true;
          }
        }).catch(err => {
           state.selectedDataAdmin = [];
           state.adminAjaxing = false;
           console.error(err);
           dataLayer.errorLog(err);
           commit('triggerSnackbar', {text:"Removing instructor failed at this time. Please try again later.", color: 'red', timeout: 6000} , {root:true});
        })
      }
    },
    createShellBulb: ({commit, state, rootState}) => {

        commit('setPopoverDataLoading', true, {root:true});
        axios.get(`${rootState.nodeApiPrefix}/admin/createbulbvideoshell`, {headers:{
           'Authorization' : `Bearer ${rootState.instructorData.token}`
        }}).then(res => {
          if(res.data.msg === 'success'){
            commit('setNewBulb', res.data.data);
            commit('setPopoverDataLoading', false, {root:true});
          }
        }).catch(err => {
           console.error(err);
           commit('setPopoverDataLoading', false, {root:true});
           commit('triggerSnackbar', {text:"Creating bulb to upload a video failed at this time. Try again later.", color: 'red', timeout: 6000} , {root:true});
           dataLayer.errorLog(err);
        })

    },
    async updateBulbShellVideo({
      commit,
      dispatch,
      state,
      rootState,
    }, videoId) {
      try {
        const { data: bulb } = await axios.get(`${rootState.nodeApiPrefix}/admin/bulb-shell-video/${state.newBulb}/${videoId}`, {
          headers: {
            Authorization: `Bearer ${rootState.instructorData.token}`,
          },
        });
        rootState.popoverToggles.addVideo = false;
        rootState.dialogShow.dash = false;
        await Vue.nextTick();
        bulb.tags = [];
        commit('handleDialogOpen', {
          data: bulb,
          type: 'bulbInfo',
        }, {
          root: true,
        });
      } catch(e) {
        dispatch('archiveShellBulb');
        commit('triggerSnackbar', {
          text: 'Adding uploaded video to bulb failed at this time. Try again later.',
          color: 'red',
          timeout: 6000
        } , {
          root: true,
        });
        dataLayer.errorLog(e);
      }
    },
    archiveShellBulb: ({commit, state, rootState}) => {
        axios.get(`${rootState.nodeApiPrefix}/admin/archiveshellbulb?bulb_id=${state.newBulb}`, {headers:{
           'Authorization' : `Bearer ${rootState.instructorData.token}`
        }}).then(res => {
          if(res.data.msg === 'success'){
          }
        }).catch(err => {
           console.error(err);
           commit('triggerSnackbar', {text:"Creating bulb to upload a video failed at this time. Try again later.", color: 'red', timeout: 6000} , {root:true});
           dataLayer.errorLog(err);
        })
    },
    searchCourse : async ({commit, state, rootState},course) => {
      commit('updateCourse', []);
      try {
        let courseData = await axios.get(`${rootState.nodeApiPrefix}/admin/search/course?course=${course}`, {headers:{
          'Authorization' : `Bearer ${rootState.instructorData.token}`
        }})
        if(courseData) {
          commit('updateCourse', courseData.data);
          state.courseLoading = false;
        }
      } catch(err) {
        console.error(err);
        commit('triggerSnackbar', {text:"Filtering data is failed. Try again later.", color: 'red', timeout: 6000} , {root:true});
        dataLayer.errorLog(err);
      }
    },
    exportSnapshot: ({commit, state, rootState}, type) => {
      console.log(type)
    },
    //Get the three folder data 
    getTreeFolder: async ({commit, rootState}) => {
      try {
        const {data} = await axios.get(`${rootState.nodeApiPrefix}/2.0/admin/node/folders`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        commit('setTreeResponseData',data);
      } catch (err) {
        commit('triggerSnackbar', {text:"Getting tree folder is failed. Try again later.", color: 'red', timeout: 6000} , {root:true});
      }
    },
    // after dragging folder updates the folder 
    dragUpdateFolder: async ({commit, state, rootState}, obj) => {
      try {
        state.adminAjaxing = true;
        const {data} = await axios.put(`${rootState.nodeApiPrefix}/2.0/admin/node/folder/${obj.id}`, obj, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}});
        commit('setUpdateTreeFolderResponse',data);
        if(data.msg === 'success') {
          state.adminAjaxing = false;
        }
      } catch(err) {
        console.error(err);
        commit('triggerSnackbar', {text:"Dragging folder is failed. Try again later.", color: 'red', timeout: 6000} , {root:true});
        state.adminAjaxing = false;
      }
    },
    // remove folder from node
    removeTreeFolder: async ({commit, state, rootState, dispatch},node) => {
      try {
        const {data} = await axios.get(`${rootState.nodeApiPrefix}/2.0/admin/node/folders?parentId=${state.selectedNode.id}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        if(data.data.length === 0){
          const {data} = await axios.delete(`${rootState.nodeApiPrefix}/2.0/admin/node/folder/${node.id}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
          if(data.msg === "success") {
            commit('setRemoveTreeFolderNode',node);
            commit('setSelectedNode', {});
          }  
        } else {
          commit('triggerSnackbar', {text:"You can't delete this folder.", color: 'red', timeout: 6000} , {root:true});
        }
      } catch (err) {
        commit('triggerSnackbar', {text:"Removing tree folder is failed. Try again later.", color: 'red', timeout: 6000} , {root:true});
      }
    },
    
    // updates dragged bulb 
    updateTreeBulbNode: async ({dispatch, commit, state, rootState},obj) => {
      try {
        const {data} = await axios.put(`${rootState.nodeApiPrefix}/admin/node/bulbs`,obj ,{headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        if(data.msg === "success") {
          dispatch('getTableData');
        }
      } catch(e) {
        console.error(e);
        commit('triggerSnackbar', {text:"Updating tree folder is failed. Try again later.", color: 'red', timeout: 6000} , {root:true});
      }
    },
  
    //Gets the sub folders
    getTreeSubFolders : async ({ commit, state, rootState}, isChildAdmin) => {
      try {
        const {data} = await axios.get(`${rootState.nodeApiPrefix}/2.0/admin/node/folders?parentId=${state.expandedNode.id}&isChildAdmin=${isChildAdmin}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        if(data.msg === "success") {
          commit('setTreeSubNodeData',data);
        }
      } catch(e) {
        console.error(e);
        commit('triggerSnackbar', {text:"Getting tree sub folders is failed. Try again later.", color: 'red', timeout: 6000} , {root:true});
      }
    },
    exportInstructorDataTable: ({commit, state, rootState}, obj) => {
      //data call to get all data for current active view and download as csv file
      let { type } = obj;
      if(!state.adminAjaxing){
        const per_page = state.queryParamsAdmin.total;
        let organization = '';
        if(state.adminFilterSearch.organization.length > 0){
          state.adminFilterSearch.organization.forEach((item, index) => {
            organization += item.value.id;
            if((index + 1 < state.adminFilterSearch.organization.length)){
              organization += ','
            }
          })
        }
        let adminOnly = false;
        if(state.adminFilterSearch.adminOnly) {
          adminOnly = true;
        }
        axios.get(`${rootState.nodeApiPrefix}/admin/csvexport?organization=${organization}&admin_only=${adminOnly}&type=${type}`, {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        .then(res => {
          if(res.data.msg === "success"){
            let data = res.data.data;
            const blob = new Blob([data]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${state.activeViewAdmin}.csv`;
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        }).catch(err => {
          console.error(err);
          dataLayer.errorLog(err);
          commit('triggerSnackbar', {text:"CSV export not working at this time", color: 'red', timeout: 6000} , {root:true});
          state.adminAjaxing = false;
        });
      }
    },
    // exportDataTable: ({commit, state, rootState}) => {
    //   //data call to get all data for current active view and download as csv file
    //   if(!state.adminAjaxing){
    //     state.adminAjaxing = true;
    //     let per_page = 0;
    //     switch (state.activeView) {
    //       case 'Instructors':
    //         per_page = state.Instructors.pagination.total;
    //         break;
    //       case 'Courses':
    //         per_page = state.Courses.pagination.total;
    //         break;
    //       case 'Students':
    //         per_page = state.Students.pagination.total;
    //         break;
    //       case 'Bulbs':
    //         per_page = state.Bulbs.pagination.total;
    //         break;
    //       default:
    //         break;
    //     }
    //     axios.get(`${rootState.nodeApiPrefix}/admin/${state.activeView}?token=${rootState.instructorData.token}&school=${state.queryParamsAdmin.school_id}&page=1&per_page=${per_page}&search=&sort=&show_archived=&master=`)
    //     .then(res => {
    //       if(res.data.msg === "success"){
    //         let data = res.data.data.data;

    //         let columnDelimiter = ',';
    //         let lineDelimiter = '\n';
    //         let keys = Object.keys(data[0]);

    //         let result = '';
    //         result += keys.join(columnDelimiter);
    //         result += lineDelimiter;

    //         data.forEach(item => {
    //           let ctr = 0;
    //           keys.forEach(key => {
    //             if(ctr > 0) result += columnDelimiter;
    //             if(typeof item[key] === 'string') {
    //               result += item[key].replace(',' , ' ');
    //             } else if(item[key] === null) {
    //               result += ' ';
    //             } else {
    //               result += item[key];
    //             }
    //             ctr ++;
    //           });
    //           result += lineDelimiter;
    //         });

    //         var blob = new Blob([result]);
    //         console.log(blob);
    //         var link = document.createElement('a');
    //         link.href = window.URL.createObjectURL(blob);
    //         link.download = `${state.activeView}.csv`;
    //         document.body.appendChild(link);
    //         link.click();
    //         link.remove();
    //       }
    //       state.adminAjaxing = false;
    //     }).catch(err => {
    //       console.error(err);
    //       dataLayer.errorLog(err);
    //       commit('triggerSnackbar', {text:"CSV export not working at this time", color: 'red', timeout: 6000} , {root:true});
    //       state.adminAjaxing = false;
    //     });
    //   }
    // }
}

const getters = {
  activeViewAdmin: state => state.activeViewAdmin,
  refreshDataAdmin: state => state.refreshDataAdmin,
  queryParamsAdmin: state => state.queryParamsAdmin,
  adminAjaxing: state => state.adminAjaxing,
  adminDataLoaded: state => state.adminDataLoaded,
  adminBatchLoading: state => state.adminBatchLoading,
  schools: state => state.schools,
  instructors: state => state.instructors,
  bulbs: state => state.bulbs,
  selectedDataAdmin: state => state.selectedDataAdmin,
  adminFilterSearch: state => state.adminFilterSearch,
  addInstructorCsv: state => state.addInstructorCsv,
  schoolList: state => state.schoolList,
  manualAddStatus: state => state.manualAddStatus,
  bulbsTakenSnapshot: state => state.bulbsTakenSnapshot,
  bulbsCreatedSnapshot: state => state.bulbsCreatedSnapshot,
  engagementSnapshot: state => state.engagementSnapshot,
  graphDataLoading: state => state.graphDataLoading,
  listDataLoading: state => state.listDataLoading,
  snapshotsettings: state => state.snapshotsettings,
  snapshotLoaded: state => state.snapshotLoaded,
  headerData: state => state.headerData,
  headerDataLoading: state => state.headerDataLoading,
  newBulb: state => state.newBulb,
  selectedNode: state => state.selectedNode,
  expandedNode: state => state.expandedNode,
  removeTreeFolderNode: state => state.removeTreeFolderNode,
  addTreeFolderNode: state=>state.addTreeFolderNode,
  treeBulbRow: state=>state.treeBulbRow,
  treeResponseData: state=>state.treeResponseData,
  treeSubNodeData: state => state.treeSubNodeData,
  updateTreeFolderResponse: state => state.updateTreeFolderResponse,
  schoolsWithChangedDefaultView: state => [1179, 1965, 1966, 1967, 906],
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
